import React, { useRef, useState, useEffect } from 'react';
import { LocationInput } from 'module-tsl-ui-jobs-location-input';
import { withRouter } from 'react-router-dom';
import { Select, Button } from 'module-tsl-ui-elements';
import AddToProfileBubble from './AddToProfileBubble';
import {FacetDropdown} from "../FacetDropdown";

export const LocationGroup = ({ point, bbox, updateLocation, i18n, history: { push }, base, displayLocation,
  maxDistance, updateMaxDistance, units, intervals, searchType, mapsApiKey,
  isMobile, canAddToProfile, loading, showDropdownTitle, selectedCount, includedTowns}) => {
  const locationInputRef = useRef();
  const [location, setLocation] = useState(displayLocation);
  const [reloadLocation, setReloadLocation] = useState(false);

  const resetLocation = (hasDisplayLocation, clearLocation) => {
    if (locationInputRef.current) {
      locationInputRef.current.resetLocation('');
      setLocation('');
    }

    if (hasDisplayLocation) {
      updateLocation({}, '', push, base, loading, clearLocation);
    }
  };

  useEffect(() => {
    if (!displayLocation) {
      locationInputRef.current.resetLocation('');
      setLocation('');
      updateLocation({}, '', push, base, loading, false);
    } else if (locationInputRef.current && !locationInputRef.current.value) {
      setLocation(displayLocation);
      setReloadLocation(!reloadLocation);
    }
  }, [displayLocation]);

  const onLocationChange = (newValue, items) => {
    const currentLocation = locationInputRef.current.value;

    if (!newValue && Boolean(currentLocation)) {
      resetLocation(Boolean(displayLocation), true);
    } else {
      setLocation(newValue);
    }

    if (items) {
      updateLocation(items, currentLocation, push, base, loading, false);
    }
  };

  const openLocationDropdown = () => {
    const targetElm = document.querySelector('.location-facet-select .Select-control span.Select-arrow-zone');
    const clickEvent = document.createEvent('MouseEvents');
    clickEvent.initEvent('mousedown', true, true);
    targetElm.dispatchEvent(clickEvent);
  };

  return (
    <div className="row">
      <div className="col-md-5 col-xs-8 margin-bottom-md">
        <div className="tds-location-search">
          { location &&
            <Button
              className="tds-location-search__clear"
              theme="tertiary"
              id="clear-location"
              onClick={() => {
                if(typeof document !== 'undefined' && document.activeElement === document.getElementsByClassName('tds-location-search__clear')[0]) {
                  resetLocation(Boolean(displayLocation), true);
                }
              }}
              iconOnly
              icon="tds-close"
              size="sm"
              data-testid="clear-location"
            />
          }
          <LocationInput
            self={{
              groupId: 'search-location-input',
              displayLocationPicker: true,
              siteCountry: (i18n && i18n.country) || 'gb',
              size: 'lg',
              throttleTimeout: 500,
            }}
            input={{
              mapsApiKey: mapsApiKey,
              onLocationChange,
              placeholder: 'Location or postcode',
              defaultValue: displayLocation,
            }}
            ref={locationInputRef}
            key={reloadLocation}
          />
          { showDropdownTitle &&
          <div className="location-selector">
            <div className="selected-locations-text">
              {selectedCount} location{selectedCount !== 1 && 's'} included.
              - <a onClick={openLocationDropdown}
                   className="link link--colored facets__heading-main t-clear-filters">Edit</a>
            </div>
            <FacetDropdown
              placeholder={`${includedTowns.length} locations included.`}
              fieldName="excludedLocations"
              groupLabel="Excluded locations"
              className={`location-facet-select${showDropdownTitle ? '' : ' hide-drop-down'}`}
              inverseSelection={true}
              clearable={false}
              valueKey="facetItemPath"
              values={includedTowns}
              onOpen={() => (document.querySelector('.location-facet-select .Select-menu') || {}).scrollTop = 0}
            />
          </div> }
        </div>

        {canAddToProfile && canAddToProfile.aspirationalLocations &&
          <AddToProfileBubble
            label={canAddToProfile.aspirationalLocations.map(l => l.name).join(', ')}
            dataToAdd={{ aspirationalLocations: canAddToProfile.aspirationalLocations }}
            isAdded={canAddToProfile.isAdded}
          />
        }
      </div>
      <div className="col-md-4 col-xs-4 margin-bottom-md padding-right-none padding-left-none">
        <Select
          id="jobs-distance"
          type="search"
          className={`t-input-distance tds-select search__postcode ${searchType === 'supply' ? 'tds-select--inverse' : ''}`}
          value={(point || bbox) ? maxDistance : ''}
          onChange={updateMaxDistance}
          name="maxdistance"
          disabled={!(point || bbox)}
          options={[{isPlaceholder: true, label: 'Distance'}].concat(intervals.map(interval => ({ value: interval.id, label: `within ${interval.value} ${units}`})))}
        />
      </div>
      { !isMobile && <div className="col-md-3 margin-bottom-md">
        <Button
          size="lg"
          isBlock
          data-mz
          data-module="search-section"
          className="t-search-button"
          type="submit"
        >
          Search
          </Button>
      </div> }
    </div>
  );
};

export const LocationGroupInputSelect = withRouter(LocationGroup);
